import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListPageComponent } from './list-page.component';

@NgModule({
  declarations: [ListPageComponent],
  imports: [
    CommonModule
  ],
  exports: [ListPageComponent]
})
export class ListPageModule { }
